<div @fade class="container-signin">
  <header class="header">
    <div class="container-logo">
      <div class="logo">
        <img (click)="goToUrl('home')" style="cursor: pointer;" src="./assets/temporals/Logo_Akana_Azul.png" alt="">
      </div>
      <div class="buttons-container">
        <p>¿Ya tienes una cuenta?</p>
        <button class="sign-in" id="changeToSignUp" (click)="goToUrl('signin')">Iniciar sesión</button>
      </div>
    </div>
  </header>
  <div class="left">
    <img src="./assets/signin/signin.svg" alt="">
  </div>
  <div class="right">
    <div class="right-container">
      <div class="form-container">
        <form method="POST" autocomplete="off" class="form-sign consumer" [formGroup]="signForm">
          <div class="no-terms">
            <img src="./assets/signin/logo_consumer2.png" alt="">
            <div class="tittle">
              <img src="./assets/signin/areaclientes.svg" alt="">
              <h2>Área Clientes</h2>
            </div>
            <div class="input-control-error">
              <p>NIF/NIE/CIF *</p>
              <input type="text" id="userId" [ngClass]="{'error-input': signForm.controls.dni.value && signForm.controls.dni.invalid &&
              signForm.controls.dni.touched || !signForm.controls.dni.value && signForm.controls.dni.touched}"
                formControlName="dni" class="input-search" name="" placeholder="Introduce un NIF/NIE/CIF" required>
              <div class="div-error"
                *ngIf="signForm.controls.dni.value && formatInvalid && signForm.controls.dni.touched">
                {{ 'SIGN.ERRORS.DNI' | translate }}
              </div>
              <div class="div-error" *ngIf="!signForm.controls.dni.value && signForm.controls.dni.touched"
                [innerHTML]=" 'SIGN.ERRORS.DNI_REQUIRED' | translate">
              </div>
            </div>
            <div class="input-control-error">
              <p>Contraseña *</p>
              <div class="see-pass">
                <input type="{{type}}" id="passwordId"
                  [ngClass]="{'error-input': !signForm.controls.password_scf.value && signForm.controls.password_scf.touched }"
                  formControlName="password_scf" class="input-search" name="" placeholder="Introduce tu contraseña"
                  required>
                <img src="./assets/signin/see_pass.svg" *ngIf="signForm.controls.password_scf.value"
                  (mousedown)="showPass(1)" (mouseup)="showPass(2)" alt="">
              </div>
              <div class="div-error"
                *ngIf="!signForm.controls.password_scf.value && signForm.controls.password_scf.touched"
                [innerHTML]=" 'SIGN.ERRORS.PASSWORD_REQUIRED' | translate">
              </div>
            </div>
            <!-- <div class="container-checkbox">
              <mat-checkbox formControlName="ofers" id="ofersId" (click)="analiticsGoogle()"></mat-checkbox>
              <p>{{'TERMS.CONDITIONS.CHECK_2' | translate}}</p>
            </div> -->
            <!-- <div class="container-checkbox">
              <mat-checkbox (click)="openWarmModal()" [disabled]="checkedTerms" formControlName="termsAndConditions"
                id="termsId" required>
              </mat-checkbox>
              <p>{{ 'TERMS.CONDITIONS.CHECK_1' | translate}}
                <strong (click)="goToUrl('terms-conditions?signin=true')"
                  class="text-box">{{'TERMS.CONDITIONS.CHECK_TERMS_1' | translate}}</strong>{{'TERMS.CONDITIONS.CHECK_BETWEEN' | translate }}
                <strong (click)="goToUrl('privacy-polity')"
                  class="text-box">{{ 'TERMS.CONDITIONS.CHECK_POLITY' | translate}}</strong>.
              </p>
            </div> -->
            <p class="errors" *ngIf="receptionMessage">{{receptionMessage}}</p>
            <button class="sign-in-consumer" [ngClass]="{'ready': signForm.valid}" (click)="login(4)"
              *ngIf="!showProgress" id="signInId">Entrar</button>
            <h3>
              <a class="consumer-pass" target="_blank"
                href="https://portalcliente.santanderconsumer.es/app/index.html#/santander/forgotPassword">He
                olvidado mi clave
              </a>
            </h3>
            <br>
            <mat-progress-bar style="width: 95%; margin: 70px auto 0 auto; max-width: 350px;" *ngIf="showProgress"
              mode="indeterminate"></mat-progress-bar>
            <div class="akana-client">
              o puede iniciar sesión como cliente Akana <br><br>
              <button class="sign-in" id="changeToSignUp" (click)="goToUrl('signin')">Iniciar
                sesión</button>
            </div>
          </div>
        </form>
      </div>
      <div class="icons-container">
        <div>
          <a target="_blank"
            href="https://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32015L2366&qid=1610532238138&from=EN">
            <img src="./assets/home/security/1.svg" alt="">
          </a>
          <a target="_blank" href="https://www.entrust.net/customer/profile?domain=akana.es&lang=en">
            <img class="special-icon" src="./assets/home/security/2.svg" alt="">
          </a>
        </div>
        <div>
          <a target="_blank" href="https://www.entrust.com/resources/certificate-solutions/learn/faq">
            <img src="./assets/home/security/3.svg" alt="">
          </a>
          <a target="_blank"
            href="https://www.bde.es/bde/es/areas/supervision/funcion/Entidades/Entidades_supervisadas.html">
            <img style="width: 110px" src="./assets/home/security/bde.png" alt="">
          </a>
        </div>
      </div>
    </div>
  </div>
  <app-footer class="footer" [colorItems]="'#ffffff'" [classSpecial]="true"></app-footer>
</div>
